import React from "react";

// Official Tiger Trailride wordmark. Black variant on light backgrounds, white on dark.
export const Logo = ({ className = "h-8", dark = false, showTagline = false }) => {
  return (
    <span className="inline-flex flex-col leading-none" aria-label="Tiger Trailride">
      <img
        src={dark ? "/logo-white.png" : "/logo-black.png"}
        alt="Tiger Trailride"
        className={`w-auto object-contain ${className}`}
      />
      {showTagline && (
        <span
          className="font-sans uppercase tracking-[0.28em] mt-3 text-[10px]"
          style={{ color: dark ? "rgba(255,255,255,0.6)" : "rgba(17,17,17,0.55)" }}
        >
          Soul &amp; Service
        </span>
      )}
    </span>
  );
};
